import { NavigationItem } from '../shared/components/navigation-tree/models/navigation-item.model';

export const NAVIGATION_ITEMS: NavigationItem[] = [
  { id: 'dashboard', path: '/dashboard', label: 'DASHBOARD.SIDEBAR.TITLE', icon: 'bi bi-speedometer2' },
  { id: 'reports', path: '/reports', label: 'REPORTS.SIDEBAR.TITLE', icon: 'bi bi-clipboard-data' },
  { id: 'rolls', path: '/rolls', label: 'ROLLS.SIDEBAR.TITLE', icon: 'bi bi-wrench-adjustable-circle' },
  { id: 'machines', path: '/machines', label: 'MACHINES.SIDEBAR.TITLE', icon: 'bi bi-gear-wide-connected' },
  { id: 'alerts', path: '/alerts', label: 'ALERTS.SIDEBAR.TITLE', icon: 'bi bi-exclamation-triangle' },
  { id: 'general-admin', path: '/general-admin', label: 'GENERAL_ADMIN.SIDEBAR.TITLE', icon: 'bi bi-key' },
  {
    id: 'notification-history',
    path: '/notification-history',
    label: 'NOTIFICATION_HISTORY.SIDEBAR.TITLE',
    icon: 'bi bi-bell',
  },
  {
    id: 'learning-platform',
    path: '/learning-platform',
    label: 'LEARNING_PLATFORM.SIDEBAR.TITLE',
    icon: 'bi bi-mortarboard',
  },
  {
    id: 'terms-of-use',
    path: null,
    label: 'TERMS_CONDITIONS.SIDEBAR.TITLE',
    icon: 'bi bi-clipboard2-minus',
    action: true,
  },
  {
    id: 'fabtrac',
    path: '/fabtrac',
    label: 'FABTRAC.SIDEBAR.TITLE',
    icon: 'bi bi-clipboard2-minus',
  },
];
